module.exports = __webpack_public_path__ + "img/img1.6d55faaf.jpg";